var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9 9.89062C15.9 13.4252 13.0346 16.2906 9.5 16.2906C5.96538 16.2906 3.1 13.4252 3.1 9.89062C3.1 6.356 5.96538 3.49063 9.5 3.49063C13.0346 3.49063 15.9 6.356 15.9 9.89062ZM14.5182 15.4645C13.1892 16.6619 11.4297 17.3906 9.5 17.3906C5.35786 17.3906 2 14.0328 2 9.89062C2 5.74849 5.35786 2.39062 9.5 2.39062C13.6421 2.39062 17 5.74849 17 9.89062C17 11.7071 16.3543 13.3727 15.2798 14.6705L22 21.3906L21.2222 22.1685L14.5182 15.4645Z",
  fill: "#001246"
})));
export default SvgSearch;